import { render } from "./FloatingChatBotV2.vue?vue&type=template&id=46d9b085&scoped=true"
import script from "./FloatingChatBotV2.vue?vue&type=script&lang=js"
export * from "./FloatingChatBotV2.vue?vue&type=script&lang=js"

import "./FloatingChatBotV2.vue?vue&type=style&index=0&id=46d9b085&lang=scss&scoped=true"
import "./FloatingChatBotV2.vue?vue&type=style&index=1&id=46d9b085&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d9b085"]])

export default __exports__